import { Box, Image } from '@wix/design-system';
import { convertElementStatusToBooleanStatus } from '@wix/rules-panel-ui';
import { StatusAlertSmall, StatusCompleteSmall } from '@wix/wix-ui-icons-common';
import React from 'react';
import { dataHooks } from '../../../../../exports/testkit';
import { resolveImageUrl } from '../../../../../utils/resolve-image-url';
export const PreviewImage = _ref => {
  let {
    image,
    dataHook
  } = _ref;
  const imageOpacity = convertElementStatusToBooleanStatus(image.status) ? 0.4 : 1;
  const urlToShow = resolveImageUrl(image.url, 50, 50);
  return /*#__PURE__*/React.createElement(Box, {
    border: "1px solid",
    borderColor: "D70",
    borderRadius: "4px",
    boxSizing: "border-box",
    dataHook: dataHook,
    height: "50px",
    position: "relative",
    width: "50px"
  }, /*#__PURE__*/React.createElement(Image, {
    borderRadius: "3px",
    dataHook: dataHooks.altTextImageGridPreviewImageImage,
    src: urlToShow,
    style: {
      opacity: imageOpacity
    }
  }), /*#__PURE__*/React.createElement(Box, {
    backgroundColor: "white",
    borderRadius: "50%",
    bottom: "5px",
    height: "12px",
    position: "absolute",
    right: "5px",
    width: "12px",
    zIndex: 1
  }), /*#__PURE__*/React.createElement(Box, {
    bottom: "2px",
    color: convertElementStatusToBooleanStatus(image.status) ? 'G10' : 'R10',
    dataHook: dataHooks.altTextImageGridPreviewImageStatusIcon,
    position: "absolute",
    right: "2px",
    zIndex: 2
  }, convertElementStatusToBooleanStatus(image.status) ? /*#__PURE__*/React.createElement(StatusCompleteSmall, null) : /*#__PURE__*/React.createElement(StatusAlertSmall, null)));
};
//# sourceMappingURL=preview-image.js.map